import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/recruitment-management-systems/candidate-communication/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "candidate-communication" entry is kept); the seo block below is a fallback.

export const candidateCommunication: ContentPage = {
  slug: "recruitment-management-systems/candidate-communication",
  template: "hrmsFeature",
  seo: {
    title: "Streamlined Communication for Enhanced Recruitment",
    description: "Maintain candidate engagement with automated, personalized communication tools that keep applicants informed and interested throughout the hiring process.",
    keywords: [
      "candidate communication",
      "recruitment automation",
      "automated email campaigns",
      "SMS notifications",
      "personalized recruitment messaging.",
    ],
    ogImage: "/assets/data/seoimages/candidate-communication.webp",
  },
  leaf: {
    hero: {
      caption: "Candidate Communication",
      title: "Enhance Candidate Engagement with Automated Communication",
      description: "Keep candidates informed and engaged throughout the recruitment process with automated, personalized communication tools.",
      h1: "caption",
    },
    split: {
      title: "Maintain Active Candidate Engagement",
      bullets: [
        { title: "Automated Email Campaigns", description: "Send updates and feedback automatically with templates." },
        { title: "Instant SMS Notifications", description: "Alert candidates about new opportunities directly." },
        { title: "Personalized Candidate Interaction", description: "Tailor communications to enhance engagement and relevance." },
        { title: "Timely Updates and Feedback", description: "Ensure candidates receive timely information throughout." },
      ],
      image: "/assets/images/img/product/hrms/recruitmentms/candidate-communication_info.webp",
      imageAlt: "candidate-communication_info",
    },
    cardsHeading: {
      title: "Key Features of Recruitment Management System",
      description: "Optimize Recruitment Management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Multi-Platform Job Posting",
        href: "/hrms-software/recruitment-management-systems/multi-platform-job-posting/",
        description: "Expand your talent search by posting jobs simultaneously across multiple job boards and social media platforms with a single click.",
        image: "/assets/images/img/product/hrms/recruitmentms/multi-platform-job-posting.webp",
        imageAlt: "multi-platform-job-posting",
      },
      {
        title: "Resume Parsing",
        href: "/hrms-software/recruitment-management-systems/resume-parsing/",
        description: "Extract and analyze candidate information efficiently with our AI-driven resume parsing technology, speeding up the recruitment process.",
        image: "/assets/images/img/product/hrms/recruitmentms/resume-parsing.webp",
        imageAlt: "resume-parsing",
      },
      {
        title: "Interview Management",
        href: "/hrms-software/recruitment-management-systems/interview-management/",
        description: "Coordinate and manage candidate interviews efficiently with our comprehensive interview management system, optimizing recruitment.",
        image: "/assets/images/img/product/hrms/recruitmentms/interview-management_image.webp",
        imageAlt: "interview-management",
      },
      {
        title: "Reporting and Analytics",
        href: "/hrms-software/recruitment-management-systems/reporting-and-analytics/",
        description: "Utilize powerful analytics and customized reports to gain insights into your recruitment process, improving decision-making and strategy.",
        image: "/assets/images/img/product/hrms/recruitmentms/reporting-and-analytics_img.webp",
        imageAlt: "reporting-and-analytics",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Keep Your Candidates Engaged and Informed!",
    relatedBlogsKeyword: "hrms-candidate-communication,small-business-recruitment-process,hr-tech-trends-recruitment",
    metaKey: "candidate-communication",
  },
  sections: [],
};
